"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodLabels = exports.PaymentMethodEnum = exports.PaymentMethod = exports.PaymentMethods = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PaymentMethods = [
    'ACCOUNT_CREDIT',
    'ACH',
    'CASH',
    'CHECK',
    'CREDIT_CARD',
    'REVENUE_SHARE',
    'WIRE',
];
exports.PaymentMethod = typebox_1.Type.Union(exports.PaymentMethods.map((method) => typebox_1.Type.Literal(method)));
/**
 * Generated enum object from PaymentMethods for use in entity-services
 */
exports.PaymentMethodEnum = exports.PaymentMethods.reduce((acc, method) => {
    acc[method] = method;
    return acc;
}, {});
exports.PaymentMethodLabels = {
    CREDIT_CARD: 'Credit / Debit Card',
    CASH: 'Cash',
    ACH: 'ACH',
    CHECK: 'Check',
    WIRE: 'Wire Transfer',
    REVENUE_SHARE: 'Revenue Share',
    ACCOUNT_CREDIT: 'Account Credit',
};
//# sourceMappingURL=payment-method.js.map